import React, { useEffect, useState } from 'react'
import { Box, Grid, Typography, Button, Dialog, DialogContent, DialogActions, makeStyles } from '@material-ui/core'
import DataService from '../../../../Service';
import CircularIndeterminate from '../../../../Components/Loader';
import moment from 'moment';

function Mail(props) {
    const classes = useStyles();
    const [docData, setDocData] = useState([])
    const [loading, setLoading] = useState(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = React.useState(false);
    const [currentID, setcurrentID] = React.useState(0);

    useEffect(() => getMails({ user_id: props.id }), [])

    const handleClickConfirmationOpen = () => {
        setConfirmationDialogOpen(true);
    };

    const handleConfirmationClose = () => {
        setConfirmationDialogOpen(false);
    };

    const getMails = (params) => {
        setLoading(true)
        DataService.getDirectData('email_logs', params)
            .then((res) => {
                setLoading(false)
                docData.length = 0;
                setDocData(docData.concat(res.email_logs))
            })
            .catch((err) => {
                setLoading(false);
            });

    }

    const deleteDoc = (id) => {
        setLoading(true)
        DataService.deleteDirectFeild('employee_personal_documents/' + id, {})
            .then((response) => {
                setLoading(false)
                var localArr = docData.filter((option) => option.id != id)
                docData.length = 0;
                setDocData(docData.concat(localArr))
            })
            .catch(() => { });
    }

    return (
        <Box p={3} alignItems="center">
            <Box>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={4}>
                        <Typography variant="h1">
                            <Box fontWeight="fontWeightBold">Emails</Box>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={5}>
                <Grid container direction="row" alignItem="center">
                    <Grid container direction="row" spacing={2} alignItem="center">
                        <Grid item xs={8}>
                            <Typography variant="subtitle1" style={{ color: "#303030" }}>
                                <Box mb={3} fontWeight="fontWeightBold">Email subject</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography variant="subtitle1" style={{ color: "#303030" }}>
                                <Box mb={3} fontWeight="fontWeightBold">Email sent date and time</Box>
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        docData.length ? docData.map((option) => {
                            return <Grid key={option.id} container direction="row" spacing={2} alignItem="center">

                                <Grid item xs={8}>
                                    <Typography variant="h2" style={{ color: "#000" }}>
                                        <Box mb={3}>{option.subject}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="h2" style={{ color: "#000" }}>
                                        <Box mb={3}>{moment(option.sent_datetime).format('MMMM Do YYYY, h:mm:ss a')}</Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        }) : <Grid container direction="row" >
                            <Grid xs={12} item><Typography variant="subtitle1" style={{ color: "#000" }}>
                                <Box mb={3}>No emails found</Box>
                            </Typography></Grid>
                        </Grid>
                    }
                </Grid>
            </Box>
            <Box>
                <Dialog onClose={handleConfirmationClose} aria-labelledby="confirmation-dialog-title" open={confirmationDialogOpen}
                >
                    <DialogContent>
                        <Box py={4} px={8}>
                            <Typography variant="h2">
                                <Box textAlign="center">Are you sure to delete?</Box>
                            </Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions disableSpacing={true} style={{ justifyContent: "center" }}>
                        <Box px={4} pb={2}>
                            <Button disableElevation variant="contained" onClick={handleConfirmationClose}>No</Button>
                            <Button disableElevation variant="contained" color="secondary" onClick={() => { handleConfirmationClose(); deleteDoc(currentID) }} style={{ marginLeft: 10 }}>Yes</Button>
                        </Box>

                    </DialogActions>
                </Dialog>
            </Box>
            {loading && <CircularIndeterminate />}

        </Box>
    )
}

export default Mail
const useStyles = makeStyles((theme) => ({
    doc_icon: { width: 16 },
    image_icon: { width: 25 },
    pdf_icon: { width: 17 },
}))
